import state from './usersystemkind.state'
import mutations from './usersystemkind.mutations'
import actions from './usersystemkind.actions'

export default {
  state,
  mutations,
  actions
}
